import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getDocumentTypeList as getDocumentTypeListApi,
	getDocumentTypeListQuery as getDocumentTypeListQueryApi,
	getDocumentType as getDocumentTypeApi,
	addNewDocumentTypeApi,
	updateDocumentTypeApi,
	deleteDocumentTypeApi,
	checkDocumentTypeExistsApi,
} from '../../helpers/document_type/api_helper';

export const getDocumentTypeList = createAsyncThunk(
	'documentType/getDocumentTypeList',
	async () => {
		try {
			const response = await getDocumentTypeListApi();
			// Extract data array from response
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener los tipos de documento.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const getDocumentTypeListQuery = createAsyncThunk(
	'documentType/getDocumentTypeListQuery',
	async params => {
		try {
			const response = getDocumentTypeListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getDocumentType = createAsyncThunk(
	'documentType/getDocumentType',
	async document_type_id => {
		try {
			const response = await getDocumentTypeApi(document_type_id);
			return response;
		} catch (error) {
			toast.error('Error al obtener el tipo de documento.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const addNewDocumentType = createAsyncThunk(
	'documentType/addNewDocumentType',
	async document_type => {
		try {
			const response = await addNewDocumentTypeApi(document_type);
			toast.success('Tipo de Documento agregado exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al agregar el tipo de documento.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateDocumentType = createAsyncThunk(
	'documentType/updateDocumentType',
	async document_type => {
		try {
			const response = await updateDocumentTypeApi(document_type);
			toast.success('Tipo de Documento actualizado exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al actualizar el tipo de documento.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteDocumentType = createAsyncThunk(
	'documentType/deleteDocumentType',
	async document_type => {
		try {
			const response = await deleteDocumentTypeApi(document_type._id);
			toast.success('Tipo de Documento eliminado exitosamente.', {
				autoClose: 3000,
			});
			// Return the original object to identify which item to remove
			return document_type;
		} catch (error) {
			toast.error('Error al eliminar el tipo de documento.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const checkDocumentTypeExists = createAsyncThunk(
	'documentType/checkDocumentTypeExists',
	async name => {
		try {
			const response = await checkDocumentTypeExistsApi(name);
			return response;
		} catch (error) {
			return { exists: false };
		}
	}
);
